"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubFilesTypesTrads = void 0;
exports.ESubFilesTypesTrads = {
    avis_imposition: "Avis d'imposition",
    carte_id: "Carte d'identité",
    carte_id_spouse: "Carte d'identité du conjoint",
    justificatif_domicile: "Justificatif de domicile",
    justificatif_origine_fonds: "Justificatif d'origine des fonds (correspondant à l'origine déclarée)",
    others: "Autres",
    rib: "RIB de perception des dividendes",
    rib_prelevement: "RIB pour prélèvement",
    product_subscribed: "Produit souscrit",
    scpi: "SCPI",
    rib_corporation: "RIB de perception des dividendes",
    rib_prelevement_corporation: "RIB pour prélèvement",
    kbis: "Kbis infogreffe (de moins de 3 mois) *",
    certified_status: "Statuts certifiés conformes (datés et signés de moins de 3 mois) *",
    card_id_legal_representative: "Carte d'identité du représentant légal",
    justificatif_domicile_legal_representative: "Justificatif de domicile du représentant légal",
    beneficiaries_list: "Liste des bénéficiaires effectifs",
    justificatif_origine_fonds_corporation: "Justificatif d'origine des fonds (correspondant à l'origine déclarée)",
    beneficiaries_id: "Carte d'identité des bénéficiaires effectifs",
    beneficiaries_justificatif_domicile: "Justificatif de domicile des bénéficiaires effectifs",
    liasse_fiscale: "Liasse fiscale ou formulaire 2072 (le cas échéant)",
    dernier_releve_compte: "Le dernier relevé de compte avec solde suffisant (recommandé)",
    contrat_mariage_pacs: "Contrat de mariage ou PACS (le cas échéant)",
};
